import {Component, OnInit} from '@angular/core';
import {AppMainComponent} from '../app.main.component';
import { MenuItem } from 'primeng/api';
import { MenuService } from './service/app.menu.service';

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html',
})
export class AppMenuComponent implements OnInit {

    model: MenuItem[];

    constructor(public app: AppMainComponent, private _menuService: MenuService) {}

    ngOnInit() {
        this._menuService.fetchMenu().subscribe(menuItems => {
            this.model = menuItems;
        });


    }

    onMenuClick(event) {
        this.app.onMenuClick(event);
    }
}
